// Module
var code = `<input type="date" aria-label="date" class="text-input" ng-model="\$ctrl.modelValue" ng-change="\$ctrl.handleValueChange()"/> `;
// Exports
export default code;